export const APPOINTMENT_SIDE_PANEL = Object.freeze({
  appointmentDefault: 'bookingLog',
  bookingLog: 'bookingLog',
  history: 'history',
  notes: 'notes',
  smsLog: 'smsLog',
  requestDeposit: 'requestDeposit',
  takeDeposit: 'takeDeposit',
});

export const CLIENT_PROFILE_SIDE_PANEL = Object.freeze({
  clientOverview: 'clientOverview',
  clientEdit: 'clientEdit',
  clientAddCredit: 'clientAddCredit',
  clientBookings: 'clientBookings',
  clientPaymentInfo: 'clientPaymentInfo',
  clientNotes: 'clientNotes',
  clientMessages: 'clientMessages',
  clientSales: 'clientSales',
  clientPatchTest: 'clientPatchTest',
  clientForms: 'clientForms',
  clientNotificationPreferences: 'clientNotificationPreferences',
});

export const SIDE_PANEL = Object.freeze({
  ...APPOINTMENT_SIDE_PANEL,
  ...CLIENT_PROFILE_SIDE_PANEL,
  timeOff: 'timeOff',
  timeOffCat: 'timeOffCategory',
  stylistLog: 'stylistLog',
  staffList: 'staffList',
});

export default SIDE_PANEL;
